import React from 'react'
import {Button, Card, CardBody, Col, Form, FormGroup, Input, Modal, Row, Table} from "reactstrap";
import LocalizedStrings from "react-localization";
import {resource_strings} from "../../translations/resource_translations";
import {common_strings} from "../../translations/common_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import stringHelpers from "../../helpers/StringHelper";
import businessApiService from "../../api/business-api-service";
import resourceHelper from "../../helpers/ResourceHelper";
import {RotateCircleLoading} from "react-loadingg";
import businessHelper from "../../helpers/BusinessHelper";
import storage from "../../Firebase";
import dateHelpers from "../../helpers/DateHelper";
import CardHeader from "reactstrap/es/CardHeader";
import ResourceApiService from "../../api/resource-api-service";
import CheckBoxList from "../Tables/CheckBoxList";

let resourceStrings = new LocalizedStrings(resource_strings);
let commonStrings = new LocalizedStrings(common_strings);

const propTypes = {};

class NewsView extends React.Component {
    handleChange = this.handleChange.bind(this);

    constructor(props) {
        super(props);

        this.fileRef = React.createRef();

        this.state = {
            ad: this.solveAd(),
            ads: props.ads,
            inputsUpdated: true,
            expiresValid: true,
            validatedOk: !!props.ad,
            setHoveredAd: null,
            mustShowCTModal: false,
            classType: null,
        };

        window.NewsView = this
    }

    renderCTModal = this.renderCTModal.bind(this);
    validate = this.validate.bind(this);
    setHoveredAd = this.setHoveredAd.bind(this);
    addMore = this.addMore.bind(this);

    componentDidMount() {
        this.getWorkshops(false);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.ad !== this.state.ad) {
            this.validate()
        }

    }

    validate() {
        const a = this.state.ad;

        const e = this.state.ad.expires;
        const ed = new Date(e);

        this.setState({
            validatedOk: (a.title && a.title.length > 1 && a.description && a.description.length > 5 && a.date && a.date.length > 4 && a.expires && a.expires.length > 4 && a.photo.length > 4),
            expiresValid: (dateHelpers.isValidDate(ed) && (ed > new Date())),
        })
    }

    handleChange(event) {

        let newValue = event.target.value;
        let targetId = event.target.id;

        switch (targetId) {
            case "input-title":
                this.setState(prevState => ({
                    ad: {
                        ...prevState.ad,
                        title: newValue
                    }
                }));
                break;
            case "input-date":
                this.setState(prevState => ({
                    ad: {
                        ...prevState.ad,
                        date: newValue
                    }
                }));
                break;
            case "input-date-end":
                this.setState(prevState => ({
                    ad: {
                        ...prevState.ad,
                        end_date: newValue
                    }
                }));
                break;
            case "input-description":
                this.setState(prevState => ({
                    ad: {
                        ...prevState.ad,
                        description: newValue
                    }
                }));
                break;
            case "input-link":
                this.setState(prevState => ({
                    ad: {
                        ...prevState.ad,
                        link: newValue
                    }
                }));
                break;
            case "input-expires":
                this.setState(prevState => ({
                    ad: {
                        ...prevState.ad,
                        expires: newValue
                    }
                }));
                break;
            default:
                return
        }
    }

    updateAd(e) {
        e.preventDefault();

        if (this.state.ad.id) {
            businessApiService.updateAd(this.state.ad)
                .then(res => {
                    console.log("AD SAVED")
                    this.props.closeAdView()
                })
                .catch((e) => {
                    console.log("AD error")
                    this.props.handleError(e)
                });
        } else {
            businessApiService.postAd(this.state.ad)
                .then(res => {
                    console.log("AD SAVED")
                    this.props.closeAdView()
                })
                .catch((e) => {
                    console.log("AD error")
                    this.props.handleError(e)
                });
        }
    }

    deleteAd(e) {
        if (e) e.preventDefault();
        this.deleteFile(this.state.ad)
    }

    handleClick(e) {
        this.fileRef.current.click();
    }

    setHoveredAd(e, ad) {
        if (e) e.preventDefault();
        this.setState({hoveredAd: ad})
    }

    onChangeFile(event) {
        this.setState({
            photoLoading: true,
        });
        event.stopPropagation();
        event.preventDefault();
        const file = event.target.files[0];
        //console.log(file);

        this.setState({file});
        this.uploadFile(file);
    }

    deleteFile(ad) {
        let imageRef = storage.refFromURL(ad.photo);
        imageRef.delete().then(() => {
            console.log("Deleted")
        }).catch(err => {
            console.log(err)
        }).finally(() => {
                if (this.state.ad.id) {
                    businessApiService.deleteAd(this.state.ad.id)
                        .then(res => {
                            this.props.closeAdView()
                        })
                        .catch((e) => {
                            this.props.handleError(e)
                        });
                }
            }
        )
    }

    uploadFile(file) {
        const businessId = businessHelper.business().id;
        const date = (new Date()).toString();
        const uploadTask = storage.ref(`ads/${businessId}/ad_${date}`).put(file);
        uploadTask.on(
            "state_changed",
            snapshot => {
                // progress function ...
                const progress = Math.round(
                    (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                );
                this.setState({progress});
            },
            error => {
                // Error function ...
                this.setState({
                    photoLoading: false,
                });
                console.log(error);
            },
            () => {
                // complete function ...
                storage
                    .ref(`ads/${businessId}`)
                    .child(`ad_${date}`)
                    .getDownloadURL()
                    .then(url => {
                        let ad = this.state.ad;
                        ad.photo = url;
                        this.setState({
                            ad: ad,
                            photoLoading: false,
                        });
                    });
            }
        );
    };

    render() {
        this.localize();
        return (
            <>
                {this.state.mustShowCTModal &&
                    this.renderCTModal()
                }

                <div>
                    {this.state.ads && this.state.ads.length > 1 &&
                        <div style={{
                            display: "flex",
                            flexFlow: "row",
                            overflowX: "auto",
                            overflowY: "hidden",
                            alignItems: "center",
                            justifyContent: "left",
                            marginLeft: 20,
                            marginRight: 20,
                            marginTop: -40,
                            marginBottom: 10
                        }}>
                            {this.state.ads.map((ad, index) => {
                                return (
                                    <span
                                        key={"ad-" + index.toString()}
                                        onMouseEnter={() => this.setHoveredAd(null, ad)}
                                        onMouseLeave={() => this.setHoveredAd(null, null)}
                                        onClick={e => this.showAnotherAd(e, ad)}
                                        style={{
                                            display: "flex",
                                            width: 150,
                                            minWidth: 150,
                                            height: 75,
                                            margin: 5,
                                            alignItems: "center",
                                            justifyContent: "center"
                                        }}>
                                    {this.state.hoveredAd && this.state.hoveredAd.id == ad.id ?
                                        (<span style={{cursor: "pointer"}}>{ad.title}</span>)
                                        :
                                        (<img
                                            style={{
                                                borderRadius: 10,
                                                maxWidth: "100%",
                                                maxHeight: "100%"
                                            }}
                                            alt="..."
                                            className=""
                                            src={ad.photo}
                                        />)
                                    }
                            </span>
                                )
                            })}
                        </div>
                    }
                    {this.state.ad && this.state.ad.id &&
                        <Button color="success" size="sm" style={{margin: 4}}
                                onClick={e => this.addMore(e)}>{commonStrings.add_more}</Button>
                    }
                </div>
                <Card className="bg-secondary shadow">
                    <CardBody>
                        <Form onSubmit={this.handleSubmit}>
                            <div className="pl-lg-4">
                                <Row>
                                    <div onClick={this.handleClick.bind(this)} style={{width: "100%", margin: '2rem'}}>
                                        <input type="file" id="file" ref={this.fileRef} style={{display: "none"}}
                                               onChange={this.onChangeFile.bind(this)}/>
                                        <div style={{
                                            textAlign: "center",
                                            width: "100%",
                                            display: "block",
                                            height: "250px",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            margin: "auto",
                                            overflow: "hidden"
                                        }}>
                                            {this.state.ad.photo ? (
                                                <img
                                                    style={{
                                                        cursor: "pointer",
                                                        borderRadius: 10,
                                                        flexShrink: "0",
                                                        marginLeft: "auto",
                                                        display: "block",
                                                        marginRight: "auto",
                                                        webkitFlexShrink: "0",
                                                        maxWidth: "100%",
                                                        maxHeight: "100%"
                                                    }}
                                                    alt="..."
                                                    className=""
                                                    src={this.state.ad.photo}
                                                />
                                            ) : (
                                                <img
                                                    style={{
                                                        cursor: "pointer",
                                                        borderRadius: 10,
                                                        flexShrink: "0",
                                                        marginLeft: "auto",
                                                        display: "block",
                                                        marginRight: "auto",
                                                        webkitFlexShrink: "0",
                                                        maxWidth: "100%",
                                                        maxHeight: "100%"
                                                    }}
                                                    src={require("assets/img/theme/placeholder.png")}
                                                />
                                            )
                                            }
                                        </div>
                                    </div>
                                    {this.state.photoLoading &&
                                        <RotateCircleLoading color="gray"/>
                                    }
                                </Row>

                                <Row>
                                    <Col lg="6">
                                        <FormGroup style={{verticalAlign: 'center='}}>
                                            <label
                                                className="form-control-label"
                                            >
                                                {stringHelpers.capitalize(resourceStrings.title)}
                                            </label>

                                            <Input
                                                placeholder={resourceStrings.title}
                                                className="form-control-alternative"
                                                onChange={this.handleChange}
                                                value={this.state.ad.title}
                                                id="input-title"
                                                type="text"
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <Row className="mt-4">
                                    <Col lg="12">
                                        <FormGroup>
                                            <label>{commonStrings.description}</label>
                                            <Input
                                                className="form-control-alternative"
                                                id="input-description"
                                                placeholder={commonStrings.description}
                                                onChange={this.handleChange}
                                                value={this.state.ad.description}
                                                rows="4"
                                                type="textarea"
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <Row className="mt-4">
                                    <Col lg="12">
                                        <FormGroup>
                                            <label>{commonStrings.link}</label>
                                            <Input
                                                className="form-control-alternative"
                                                id="input-link"
                                                placeholder={"https://..."}
                                                onChange={this.handleChange}
                                                value={this.state.ad.link}
                                                type="text"
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <Row className="mt-4">
                                    <Col lg="12">

                                        <div>
                                            <Button
                                                color="secondary"
                                                size="lg"
                                                onClick={e => this.showCTModal(e)}
                                            >
                                                {this.state.classType ? this.state.classType.name : resourceStrings.link_workshop}
                                            </Button>

                                            {this.state.classType &&
                                                <Button
                                                    color="danger"
                                                    size="xs"
                                                    onClick={e => this.unlinkWorkshop(e)}
                                                >
                                                    x
                                                </Button>
                                            }

                                        </div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col lg="12">
                                        <label style={{marginTop: 10, marginLeft: 10, fontSize: '0.8rem'}}>
                                            {resourceStrings.link_workshop_expl}
                                        </label>
                                    </Col>
                                </Row>

                                <Row className="mt-4">
                                    <Col lg="6" xl="4" sm="12">
                                        <FormGroup>
                                            <label
                                                className="form-control-label"
                                                htmlFor="input-date"
                                            >
                                                {commonStrings.date}
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                onChange={this.handleChange}
                                                value={dateHelpers.cleanup(this.state.ad.date)}
                                                id="input-date"
                                                type="date"
                                            />
                                        </FormGroup>
                                    </Col>

                                    <Col lg="6" xl="4" sm="12">
                                        <FormGroup>
                                            <label
                                                className="form-control-label"
                                                htmlFor="input-date-end"
                                            >
                                                {commonStrings.date_end}
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                onChange={this.handleChange}
                                                value={dateHelpers.cleanup(this.state.ad.end_date)}
                                                id="input-date-end"
                                                type="date"
                                            />
                                        </FormGroup>
                                    </Col>

                                    <Col lg="6" xl="4" sm="12">
                                        <FormGroup>
                                            <label
                                                className="form-control-label"
                                                htmlFor="input-expires"
                                            >
                                                {resourceStrings.dont_show_after}
                                            </label>

                                            <Input
                                                className={this.state.expiresValid ? "form-control-alternative" : "is-invalid"}
                                                onChange={this.handleChange}
                                                value={dateHelpers.cleanup(this.state.ad.expires)}
                                                id="input-expires"
                                                type="date"
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>

                            </div>
                            {!this.state.validatedOk &&
                                <div className="m-2 text-center">
                                    <small style={{color: "red"}}>{commonStrings.ad_reqs}</small>
                                </div>
                            }
                            <Row>
                                <Col lg="12">
                                    <Col className="text-right" style={{padding: 0}}>
                                        {this.state.ad && this.state.ad.id &&
                                            <Button
                                                style={{margin: 4}}
                                                color="danger"
                                                outline="button"
                                                size="lg"
                                                onClick={e => this.deleteAd(e)}
                                            >
                                                {commonStrings.delete}
                                            </Button>
                                        }
                                        <Button
                                            style={{margin: 4}}
                                            color="warning"
                                            outline="button"
                                            size="lg"
                                            onClick={e => this.props.closeAdView(e)}
                                        >
                                            {commonStrings.close}
                                        </Button>

                                        <Button
                                            style={{margin: 4}}
                                            color="default"
                                            size="lg"
                                            disabled={!this.state.validatedOk}
                                            onClick={e => this.updateAd(e)}
                                        >
                                            {commonStrings.save}
                                        </Button>
                                    </Col>
                                </Col>
                            </Row>

                        </Form>
                    </CardBody>
                </Card>
            </>
        )
    }

    toggleCTModal = state => {
        this.setState({
            mustShowCTModal: !this.state.mustShowCTModal
        });
    };

    getWorkshops(mustShowModalOnResult = true) {
        this.setState({isLoading: true});

        ResourceApiService.loadWorkshops()
            .then(res => {
                let ct = null;

                if (res && this.state.ad && this.state.ad.class_type_id) {
                    ct = res.find(ct => ct.id === this.state.ad.class_type_id)
                }

                this.setState({
                    classTypes: res,
                    classType: ct,
                    isLoading: false,
                });

                if (mustShowModalOnResult) {
                    this.showCTModal()
                }

            })
            .catch((e) => {
                this.props.handleError(e)
            });
    }

    unlinkWorkshop(e) {
        if (e) e.preventDefault();

        this.setState(prevState => ({
            ad: {
                ...prevState.ad,
                class_type_id: null
            }
        }));
        this.setState({classType: null});
    }

    showCTModal(e) {
        if (e) e.preventDefault();

        if (this.state.classType === null) {
            this.setState({classType: this.state.ad.classType});
        }

        if (this.state.classTypes === null) this.getWorkshops();
        else {
            this.setState({mustShowCTModal: true})
        }
    }

    renderCTModal() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.state.mustShowCTModal}
                toggle={() => this.toggleCTModal("formModal")}
            >
                <div className="modal-header">
                    <h6 className="modal-title" id="modal-title-notification">
                        {resourceStrings.link_workshop}
                    </h6>
                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => this.toggleCTModal()}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>

                <div className="modal-body p-0">

                    <Card className="bg-secondary shadow border-0">
                        {(!this.state.classTypes || this.state.classTypes.length === 0) &&
                            <CardHeader className="bg-transparent pb-2">
                                <div className="text-muted text-center mt-2 mb-3">
                                    <small style={{color: "red"}}>{resourceStrings.no_workshops}</small>
                                </div>
                            </CardHeader>
                        }
                        <Table
                            className="align-items-center table-light table-flush mt-2"
                            responsive
                        >
                            <tbody>
                            {this.renderCTable()}
                            </tbody>
                        </Table>
                    </Card>
                </div>
            </Modal>
        )
    }

    handleCTSelected(checked, id) {
        const tt = this.state.classTypes.find(it => it.id === id);
        this.setState(prevState => ({
            ad: {
                ...prevState.ad,
                class_type_id: tt.id
            }
        }));
        this.setState({classType: tt, mustShowCTModal: false});

        if (!this.state.ad.title || this.state.ad.title.length === 0) {
            this.setState(prevState => ({
                ad: {
                    ...prevState.ad,
                    title: tt.name
                }
            }));
        }

        if (!this.state.ad.description || this.state.ad.title.description === 0) {
            this.setState(prevState => ({
                ad: {
                    ...prevState.ad,
                    description: tt.description
                }
            }));
        }
    }

    renderCTable() {
        const selected = [this.state.classType]
        return (this.state.classTypes).map((tt, index) => {

            return (
                <CheckBoxList item={{id: tt.id, label: tt.name}} key={tt.id}
                              selected={selected.includes(tt.id)}
                              handleChange={this.handleCTSelected.bind(this)}/>
            )
        })
    };

    addMore(e) {
        e.preventDefault();
        this.setState({ad: resourceHelper.emptyAd(), classType: null})
    }

    localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    solveAd() {
        return (this.props.ad === null || this.props.ad === undefined) ? resourceHelper.emptyAd() : this.props.ad
    }

    showAnotherAd(e, ad) {
        if (e) e.preventDefault();
        this.setState({ad: ad})
    }
}

NewsView.propTypes = propTypes;

export default NewsView;